(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('SurveyResponse', SurveyResponse);

    SurveyResponse.$inject = ['$resource'];

    function SurveyResponse ($resource) {
        var resourceUrl =  'api/survey-responses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
